// src/pages/OrderViewer/styles.ts
import styled from "styled-components";

export const PageContainer = styled.div`
  max-width: 900px;
  margin: 32px auto 48px;
  padding: 0 16px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 6px 0;
  margin: 0 0 12px;
  cursor: pointer;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-size: 14px;
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.teal};
`;

export const Title = styled.h1`
  font-weight: 900;
  font-size: 22px;
  color: ${(p) => p.theme.tokens.colors.ink};
  margin: 0 0 4px;
`;

export const Intro = styled.p`
  color: ${(p) => p.theme.tokens.colors.muted};
  font-size: 13.5px;
  margin: 0 0 20px;
`;

export const LoadingBox = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
`;

export const ErrorBanner = styled.div<{ $tone?: "error" | "info" }>`
  padding: 12px 14px;
  border-radius: ${(p) => p.theme.tokens.radii.md}px;
  font-size: 13px;
  font-weight: 700;
  margin: 10px 0;
  font-family: ${(p) => p.theme.tokens.font.family};
  ${(p) =>
    p.$tone === "info"
      ? `background: ${p.theme.tokens.colors.softBg}; color: ${p.theme.tokens.colors.muted};`
      : `background: ${p.theme.tokens.colors.red}18; color: ${p.theme.tokens.colors.red};`}
`;
